export const CREATE_DOCTOR_MACRO = 'doctorMacros/CREATE_DOCTOR_MACRO';
export const DELETE_DOCTOR_MACRO = 'doctorMacros/DELETE_DOCTOR_MACRO';
export const GET_MACROS_FOR_DROPDOWN = 'doctorMacros/GET_MACROS_FOR_DROPDOWN';
export const GET_DOCTOR_MACROS_LIST = 'doctorMacros/GET_DOCTOR_MACROS_LIST';

export function createDoctorMacro(fields) {
    return {
        type: CREATE_DOCTOR_MACRO,
        httpRequest: {
            method: 'post',
            path: '/doctorMacros/',
            data: {
                ...fields,
            },
        },
    };
}

export function getDoctorMacrosList({offset, limit}) {
    return {
        type: GET_DOCTOR_MACROS_LIST,
        httpRequest: {
            method: 'get',
            path: '/doctorMacros/list',
            params: {
                offset,
                limit,
            },
        },
        offset,
        limit,
    };
}

export function getDoctorMacrosForDropdown(search, patientId) {
    return {
        type: GET_MACROS_FOR_DROPDOWN,
        httpRequest: {
            method: 'get',
            path: '/doctorMacros/dropdown/list',
            params: {
                search,
                patientId,
            },
        },
    };
}

export function deleteDoctorMacro(macroId) {
    return {
        type: DELETE_DOCTOR_MACRO,
        httpRequest: {
            method: 'del',
            path: `/doctorMacros/${macroId}`,
        },
        id: macroId,
    };
}



// WEBPACK FOOTER //
// ./src/reducers/doctorMacros/doctorMacrosActions.js